import React, { memo } from 'react'

import styled from '@emotion/styled'

import { AnimatedSurglogsLogo } from '../uiKit'
import { Box } from '../uiKit/components/Box'

const spinkitSize = 40

const StyledContainer = styled(Box)`
  position: absolute;
  top: calc(50% - 30px);
  left: calc(50% - 40px);
  width: ${spinkitSize * 2}px;
  text-align: center;
`

export const SurglogsLoader = memo(() => (
  <StyledContainer>
    <AnimatedSurglogsLogo />
  </StyledContainer>
))
